import "core-js/modules/es.array.reverse.js";
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { runInAction, observable, makeObservable } from "mobx";
import L from "leaflet";
export let LeafletAttribution = (_class = class LeafletAttribution extends L.Control.Attribution {
  constructor(terria) {
    const options = {
      position: "bottomleft"
    };
    if (terria.configParameters.leafletAttributionPrefix) {
      options.prefix = terria.configParameters.leafletAttributionPrefix;
    }
    super(options);
    _defineProperty(this, "_attributions", void 0);
    _defineProperty(this, "map", void 0);
    _defineProperty(this, "_container", void 0);
    _initializerDefineProperty(this, "dataAttributions", _descriptor, this);
    makeObservable(this);
    this._attributions = {};
    this.dataAttributions = observable([]);
  }
  onAdd(map) {
    map.attributionControl = this;
    this.map = map;
    this._container = L.DomUtil.create("div", "leaflet-control-attribution");
    L.DomEvent.disableClickPropagation(this._container);
    map.eachLayer(layer => {
      if (layer.getAttribution) {
        const att = layer.getAttribution();
        if (att) this.addAttribution(att);
      }
    });
    return this._container;
  }
  onRemove() {
    this.map = undefined;
  }
  _update() {
    if (!this.map) {
      return;
    }
    const attribs = [];
    const attributions = this._attributions;
    for (const i in attributions) {
      if (attributions[i]) {
        attribs.push(i);
      }
    }
  }
  addAttribution(text) {
    super.addAttribution(text);
    if (this.map) {
      runInAction(() => {
        this.dataAttributions.push(text);
      });
    }
    return this;
  }
  removeAttribution(text) {
    super.removeAttribution(text);
    if (this.map) {
      runInAction(() => {
        this.dataAttributions.remove(text);
      });
    }
    return this;
  }
  get attributions() {
    const attributionsList = [];
    const attributions = this._attributions;
    for (const i in attributions) {
      if (attributions[i]) {
        attributionsList.push(i);
      }
    }
    return attributionsList;
  }
  get prefix() {
    if (!this.options.prefix) return undefined;
    return "".concat(this.options.prefix);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataAttributions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);